import { render, staticRenderFns } from "./LogoutMsgView.vue?vue&type=template&id=304f2382&scoped=true&"
import script from "./LogoutMsgView.vue?vue&type=script&lang=js&"
export * from "./LogoutMsgView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304f2382",
  null
  
)

export default component.exports